import * as React from 'react';
import locales from '../locales';
import * as moment from 'moment';
import {ColumnFilterItem} from "antd/lib/table";

export const enum AlertState {
  NEW = 'NEW',
  TRIGGERED = 'TRIGGERED',
  HANDLED = 'HANDLED'
}

const stateToColorClass = {
  [AlertState.NEW]: 'green',
  [AlertState.TRIGGERED]: 'red',
  [AlertState.HANDLED]: 'gray',
};

const stateToText = {
  [AlertState.NEW]: locales.alert_state_new,
  [AlertState.TRIGGERED]: locales.alert_state_triggered,
  [AlertState.HANDLED]: locales.alert_state_handled,
};

export function determineAlertState(alert: moment.Moment, handled: moment.Moment | null) {
  if (handled) {
    return AlertState.HANDLED;
  } else if (alert.isBefore(moment())) {
    return AlertState.TRIGGERED;
  } else {
    return AlertState.NEW;
  }
}

export function renderAlertState(state: string | undefined): React.ReactNode {
  const txt = state ? stateToText[state] : locales.alert_state_new;
  return (
    <div style={{whiteSpace: 'nowrap'}}>
      <span style={{marginRight: 8}}>{txt}</span>
      {renderStateSpan(state)}
    </div>
  );
}

export function renderAlertStateCondensed(state: string | undefined): React.ReactNode {
  const txt = state ? stateToText[state] : locales.alert_state_new;
  return (
    <div style={{textAlign: 'center'}} title={txt}>
      {renderStateSpan(state)}
    </div>
  );
}

function renderStateSpan(state: string | undefined): React.ReactNode {
  const colorCls = state ? stateToColorClass[state] : 'grey';
  return <span className={'state-dot ' + colorCls}/>;
}

export function getAlertStateFilters(): ColumnFilterItem[] {
  return [AlertState.NEW, AlertState.TRIGGERED, AlertState.HANDLED]
    .map(state => ({text: stateToText[state], value: state}));
}


// WEBPACK FOOTER //
// ./src/alerts/state.tsx